import { makeAutoObservable } from "mobx";
import { formatAddress, } from "..";
import { ApartmentInfo, ApartmentInfoStorageManager, FULFILLMENT_METHOD_STORAGE_KEY, FulfillmentMethodTypeStorageManager, ONLINE_CONTACT_DETAILS_KEY, } from "../..";
export class POnlineOrderDetails {
    constructor(params) {
        this.type = "Online";
        this.isFulfillmentEditable = true;
        this.restaurant = params.restaurant;
        this.country = params.country;
        this.fulfillmentInstructions = params.fulfillmentInstructions;
        this.promotionScheme = params.promotionScheme;
        makeAutoObservable(this);
    }
    initialize() {
        this.promotionScheme.initialize();
    }
    dispose() {
        this.promotionScheme.dispose();
    }
    get promotionInstances() {
        return this.promotionScheme.promotionInstances;
    }
    clearCoupon() {
        this.promotionScheme.clearCoupon();
    }
    get couponState() {
        return this.promotionScheme.couponState;
    }
    get isDelivery() {
        return this.fulfillmentInstructions.isDelivery;
    }
    get isPostCodeRequired() {
        return this.fulfillmentInstructions.deliveryAddress.streetAddress
            .isPostCodeRequired;
    }
    get deliveryAddressStatus() {
        return this.fulfillmentInstructions.deliveryAddress.status;
    }
    get fulfillmentMethodType() {
        return this.fulfillmentInstructions.fulfillmentMethodType;
    }
    get formattedAddress() {
        var _a;
        switch (this.fulfillmentInstructions.fulfillmentMethodType) {
            case "Delivery":
            case "NoContactDelivery": {
                const { streetAddress } = this.fulfillmentInstructions.deliveryAddress;
                return formatAddress(streetAddress, streetAddress.isPostCodeRequired);
            }
            case "DineIn":
            case "Takeaway": {
                const { address } = this.restaurant;
                return formatAddress({
                    street: (_a = address.street) !== null && _a !== void 0 ? _a : "",
                    streetNumber: "",
                    city: address.city,
                    postCode: address.postCode,
                }, true // As default show restaurant's post code
                );
            }
            // TODO: remove this when fulfillmentMethodType will not be nullable
            default:
                return { firstLine: "", secondLine: "" };
        }
    }
    get doesAnyPromotionRequireMarketingConsents() {
        return this.promotionScheme.doesAnyPromotionRequireMarketingConsents;
    }
    disableMarketingPromotionInstances() {
        this.promotionScheme.disableMarketingPromotionInstances();
    }
    // TODO: remove this?
    get isStoredFulfillmentMethodCart() {
        return localStorage.getItem(FULFILLMENT_METHOD_STORAGE_KEY) !== null;
    }
    // TODO: remove this?
    get isStoredFulfillmentMethodCheckout() {
        const apartmentInfo = new ApartmentInfoStorageManager({
            country: this.country,
        }).restore();
        const fulfillmentMethod = new FulfillmentMethodTypeStorageManager().restore();
        if (fulfillmentMethod === "Takeaway" || fulfillmentMethod === "DineIn") {
            return true;
        }
        else {
            return (fulfillmentMethod !== null &&
                apartmentInfo !== null &&
                !ApartmentInfo.fromStorageData({
                    country: this.country,
                    storageData: apartmentInfo,
                }).isEmpty);
        }
    }
    // TODO: remove this?
    // TODO: check that stored value is available / valid
    get isStoredContact() {
        return localStorage.getItem(ONLINE_CONTACT_DETAILS_KEY) !== null;
    }
}
